import React from "react";

export default function Packages({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="21.602"
      viewBox="0 0 18 21.602"
      className={color}
    >
      <g id="Group_329" dataname="Group 329" transform="translate(0 0)">
        <path
          id="Path_132"
          dataname="Path 132"
          d="M17.3,3.6H14.6V.9a.85.85,0,0,0-.9-.9H8.3a.85.85,0,0,0-.9.9V3.6H4.7A2.651,2.651,0,0,0,2,6.3V8.1H20V6.3a2.651,2.651,0,0,0-2.7-2.7ZM9.2,1.8h3.6V3.6H9.2Z"
          transform="translate(-1.999 0.002)"
        />
        <path
          id="Path_133"
          dataname="Path 133"
          d="M2,11v9a.9.9,0,0,0,.9.9h.9v.9a.85.85,0,0,0,.9.9.85.85,0,0,0,.9-.9v-.9H16.4v.9a.9.9,0,1,0,1.8,0v-.9h.9A.9.9,0,0,0,20,20V11Zm10.8,4.5H9.2a.9.9,0,0,1,0-1.8h3.6a.9.9,0,1,1,0,1.8Z"
          transform="translate(-2 -1.099)"
        />
      </g>
    </svg>
  );
}
